export default function*() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) yield node;
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/iterator.js
// module id = 39
// module chunks = 0